import { t } from 'i18next'
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown'
import React, { useState } from 'react'

export const LanguageSelect = () => {
  const storedLanguage = localStorage.getItem('i18nextLng')

  const [activeLanguage, setActiveLanguage] = useState<string>(
    storedLanguage ? storedLanguage : 'de'
  )
  const handleChange = (event: DropdownChangeParams): void => {
    const selectedLanguage = event.target.value
    localStorage.setItem('i18nextLng', selectedLanguage)
    setActiveLanguage(selectedLanguage)
    //refreshing page
    window.location.reload()
  }

  return (
    <Dropdown
      ariaLabel={t('core.change_language')}
      className={'mb-2 small-text flex no-dropdown-icon'}
      style={{ fontSize: 'small', verticalAlign: 'top' }}
      value={activeLanguage}
      type={'button'}
      options={[
        { label: 'de', value: 'de' },
        { label: 'fr', value: 'fr' },
      ]}
      onChange={handleChange}
      tooltip={t('core.change_language')}
      tooltipOptions={{ showDelay: 3000, style: { width: '340px' } }}
    />
  )
}